const projects = [
  {
    name: "SOU-BUDE",
    description: "Public bike sharing app for Android and iOS — 2023",
    image: "/img/sou/bg.png",
    shape: "/img/shapes/shape1.png",
    alt: "SOU-BUDE project artwork",
  },
  {
    name: "PropEVE CRM",
    description: "Customer relationship management solution for PropEVE — 2023",
    image: "/img/propeve/bg.png",
    shape: "/img/shapes/shape3.png",
    alt: "PropEVE CRM project artwork",
  },
  {
    name: "Indeanta Mobility App",
    description: "In-campus all-electric mobility platform — 2023",
    image: "/img/indeanta/bg.png",
    shape: "/img/shapes/shape2.png",
    alt: "Indeanta Mobility App project artwork",
  },
];

function Work() {
  return (
    <section className="work">
      <div className="section-shell">
        <div className="section-heading">
          <span className="eyebrow">Selected Work</span>
          <h2>Projects I’ve helped bring to life.</h2>
        </div>

        <div className="project-grid">
          {projects.map((project) => (
            <article key={project.name} className="project-card">
              <div className="project-media">
                <img className="project-shape" src={project.shape} alt="" />
                <img className="project-cover" src={project.image} alt={project.alt} />
              </div>
              <div className="project-copy">
                <h3>{project.name}</h3>
                <p>{project.description}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Work;
